import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

interface NoPermissionProps {
  /** Optional: angezeigter Modul-Name fuer den Kontext. */
  moduleName?: string;
}

/**
 * Anzeige bei fehlender Berechtigung — ersetzt stille Redirect-Schleifen.
 * Tester-Fund 2026-05-19: handwerker landete auf /m/bauberichteV2/auswertung
 * → Redirect ins Disposition-Modul → kein Zugriff → ModuleRouter-Redirect zurueck
 * zur Index-Page → Index leitet wieder auf die geschuetzte Seite → leere Seite.
 * Wer keine Berechtigung hat, sieht jetzt eine klare Hinweis-Seite.
 */
export default function NoPermission({ moduleName }: NoPermissionProps) {
  return (
    <div className="max-w-md mx-auto mt-12 p-6 rounded-xl border border-slate-800 bg-slate-900/40 text-center">
      <ShieldOff size={40} className="mx-auto text-amber-400 mb-3" />
      <h1 className="text-lg font-semibold text-slate-100 mb-2">Keine Berechtigung</h1>
      <p className="text-sm text-slate-400">
        {moduleName
          ? `Du hast keinen Zugriff auf das Modul "${moduleName}".`
          : 'Du hast keinen Zugriff auf diesen Bereich.'}
        {' '}Bitte einen Admin um Freischaltung, falls das ein Fehler ist.
      </p>
      <Link
        to="/"
        className="inline-block mt-4 px-4 py-2 rounded-lg bg-brand-600/20 border border-brand-600/40 text-brand-200 hover:bg-brand-600/30 transition-colors text-sm"
      >
        Zur Startseite
      </Link>
    </div>
  );
}
